import type { CrmScreenKey } from './CrmApiPort';

/**
 * รายการหน้าจอของโมดูล — ใช้ร่วมกันทั้งสองโหมด
 *
 *   embed      เมนูเดียวชื่อ MeCRM ที่ host → โมดูลต้องมีเมนูย่อยของตัวเอง
 *   standalone AppShell ใช้รายการเดียวกันนี้ผูกกับ URL
 *
 * ⚠️ ลำดับในนี้คือลำดับที่ผู้ใช้เห็น เรียงตามงานที่ทำบ่อยที่สุดก่อน
 *    หน้าที่ยังไม่ได้ต่อ backend ก็อยู่ในรายการ เพราะออกแบบไว้แล้วและใช้เดโมได้
 */

export interface CrmNavItem {
  screen: CrmScreenKey;
  label: string;
  /** ชื่อไอคอน Material Symbols */
  icon: string;
  /** path ของโหมด standalone — ตรงตามที่ screens/README กำหนด ไม่ได้ตั้งใหม่ */
  path: string;
}

export interface CrmNavGroup {
  title: string;
  items: CrmNavItem[];
}

export const CRM_NAV: CrmNavGroup[] = [
  {
    title: 'คิวงานประจำวัน',
    items: [
      { screen: 'claim-queue', label: 'คิวตรวจคำขอ', icon: 'inbox', path: '/queue/claims' },
      { screen: 'claim-order-id', label: 'คำขอจากเลขคำสั่งซื้อ', icon: 'receipt_long', path: '/queue/claims/order-id' },
      { screen: 'claim-bulk', label: 'ตรวจหลายรายการ', icon: 'done_all', path: '/queue/claims/bulk' },
    ],
  },
  {
    title: 'ตั้งค่าโปรแกรมสะสมคะแนน',
    items: [
      { screen: 'point-rule', label: 'กติกาคะแนน', icon: 'calculate', path: '/settings/points' },
      { screen: 'tier', label: 'ระดับสมาชิก', icon: 'workspace_premium', path: '/settings/tiers' },
    ],
  },
  {
    title: 'การตลาด',
    items: [
      { screen: 'privilege', label: 'สิทธิพิเศษ', icon: 'redeem', path: '/marketing/privileges' },
      { screen: 'reward-catalog', label: 'ของรางวัล', icon: 'inventory_2', path: '/marketing/rewards' },
      { screen: 'coupon', label: 'คูปองส่วนลด', icon: 'confirmation_number', path: '/marketing/coupons' },
      { screen: 'banner', label: 'แบนเนอร์หน้าแรก', icon: 'view_carousel', path: '/marketing/banners' },
    ],
  },
];

/** แปลง path → screen สำหรับตอนกดลิงก์ข้ามหน้าในโหมด embed */
export const SCREEN_BY_PATH: Record<string, CrmScreenKey> = CRM_NAV
  .flatMap((g) => g.items)
  .reduce((acc, item) => ({ ...acc, [item.path]: item.screen }), {});
